import React, { useEffect, useState } from "react";
import MAP from "@/data/mpDistrictPaths.json";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { MPDistrictMap, METRICS, useDistrictIndex } from "@/components/gov/MPDistrictMap";
import { DistrictPanel } from "@/components/gov/DistrictPanel";

const PARENT = Object.fromEntries(MAP.districts.flatMap((d) => d.includes.map((c) => [c, d.name])));

export function DistrictMapSection() {
  const { t } = useLang();
  const [rows, setRows] = useState([]);
  const [metric, setMetric] = useState("demand");
  const [sel, setSel] = useState(null);
  const index = useDistrictIndex(rows);
  useEffect(() => { api.get("/reports/district-stats").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const newer = Object.keys(PARENT);

  return (
    <section className="rounded-lg border border-slate-200 bg-white p-5" data-testid="gov-map-section">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-lg font-semibold text-slate-900 brand-heading">{t("gmap_title")}</h2>
          <p className="text-xs text-slate-500 mt-0.5">{t("gmap_sub")}</p>
        </div>
        <div className="inline-flex rounded-md border border-slate-200 p-0.5 bg-slate-50" role="tablist">
          {METRICS.map((m) => (
            <button key={m} onClick={() => setMetric(m)} data-testid={`map-metric-${m}`}
              className={`px-3 py-1.5 text-xs font-semibold rounded ${metric === m ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"}`}>
              {t(`gmap_metric_${m}`)}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 xl:grid-cols-5 gap-5">
        <div className="xl:col-span-3">
          <MPDistrictMap rows={rows} metric={metric} selected={sel} onSelect={setSel} />
          <div className="mt-3 text-[11px] text-slate-500 flex flex-wrap items-center gap-2">
            <span>{t("gmap_newer")}</span>
            {newer.map((n) => (
              <button key={n} onClick={() => setSel(n)} data-testid={`map-newer-${n}`} className={`rounded-full border px-2 py-0.5 ${sel === n ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 hover:border-slate-500"}`}>{n}</button>
            ))}
          </div>
        </div>
        <div className="xl:col-span-2">
          <DistrictPanel row={sel ? index[sel] : null} parentOf={sel ? PARENT[sel] : null} onClose={() => setSel(null)} />
        </div>
      </div>
    </section>
  );
}
